import { useState } from "react";
import { Copy, Check, MapPin } from "lucide-react";
import { toast } from "sonner";
import { appleMapsUrl, googleMapsUrl, mapsQueryFromUrl, copyToClipboard } from "./DirectionsActions";

// Inline markdown link to a maps URL → Google link (as written) + tiny Apple + Copy affordances. Sitewide standard.
export const InlineMapLink = ({ href, label, className, style }) => {
  const [copied, setCopied] = useState(false);
  const addr = mapsQueryFromUrl(href);
  if (!addr) return <a href={href} target="_blank" rel="noopener noreferrer" className={className} style={style}>{label}</a>;
  const copy = async (e) => {
    e.preventDefault();
    if (await copyToClipboard(addr)) { setCopied(true); toast.success("Address copied"); setTimeout(() => setCopied(false), 1800); } else toast.error("Couldn't copy");
  };
  const tiny = "inline-flex items-center align-middle rounded-full border px-1.5 py-0.5 text-[10px] font-bold no-underline hover:opacity-80 ml-1";
  return (
    <span className="inline" data-testid="inline-map-link">
      <a href={googleMapsUrl(addr, null, null, "find")} target="_blank" rel="noopener noreferrer" className={className} style={style}>{label}</a>
      <a href={appleMapsUrl(addr, null, null, "find")} target="_blank" rel="noopener noreferrer" className={tiny} style={{ color: style?.color, borderColor: "currentColor" }} title="Open in Apple Maps" data-testid="inline-map-apple"><MapPin className="h-3 w-3" />&nbsp;Apple</a>
      <button type="button" onClick={copy} className={tiny} style={{ color: style?.color, borderColor: "currentColor" }} title="Copy address" data-testid="inline-map-copy">{copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}&nbsp;{copied ? "Copied" : "Copy"}</button>
    </span>
  );
};
